module.exports = __webpack_public_path__ + "static/media/undraw_account_490v.6fb2c3da.svg";